import { create } from 'zustand';

export type ToastTone = 'good' | 'warn' | 'critical' | 'info';

export interface Toast {
  id: string;
  tone: ToastTone;
  title: string;
  body?: string;
  /** Auto-dismiss timer, ms. 0 = sticky until user dismisses. */
  durationMs: number;
}

interface ToastStore {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

let nextId = 0;

export const useToasts = create<ToastStore>((set) => ({
  toasts: [],
  push: (t) => {
    const id = `toast-${++nextId}-${Date.now()}`;
    set((s) => ({ toasts: [...s.toasts, { ...t, id }] }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
  clear: () => set({ toasts: [] }),
}));
